import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import ProgrammationGroupsList from './ProgrammationGroupsList/ProgrammationGroupsList';
import ProgrammationGroupEdit from './ProgrammationGroupEdit/ProgrammationGroupEdit';
import ProgrammationGroupCreate from './ProgrammationGroupCreate/ProgrammationGroupCreate';
import ProgrammationGroupDelete from './ProgrammationGroupDelete/ProgrammationGroupDelete';

import './ProgrammationGroups.css';

const ProgrammationGroups = ({ match }) => {
    return (
        <div className="ProgrammationGroups">
            <ContainerWrapper container="programmation_groups">
                <Route exact path={ match.path } component={ProgrammationGroupsList} />
                <Route exact path={ `${ match.url }/new/:events_ids?` } component={ProgrammationGroupCreate} />
                <Route exact path={ `${ match.url }/edit/:groupId` } component={ProgrammationGroupEdit} />
                <Route exact path={ `${ match.url }/delete/:groupId` } component={ProgrammationGroupDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default ProgrammationGroups;
